import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Alert } from 'antd';
import {bindActionCreators} from 'redux';
import {Layout, Menu, Icon, Spin} from 'antd';
import Utils from '../script/utils';
import {withRouter} from 'react-router-dom'
const {Content} = Layout;

import Store from '../script/store';
import * as homeActions from '../actions/home_action';
import * as loginActions from '../actions/login_action';
import * as closeActions from '../actions/close_action';
import Navbar from '../components/layout/navbar';
import SideMenu from '../components/layout/sideMenu';
import SplitPane from "react-split-pane";
import AiAssistant from '../components/ai/AiAssistant.js';

class PageApp extends Component {
  state = {
    sideCollapsed: true,
    hasPermission: false,
    slitPaneProps: { //slitPane(切屏)属性
      split: 'vertical',
      size: 250,
      minSize: 220,
      maxSize: 600,
    },
  }

  componentWillMount() {
    this.props.homeActions.getUserIP();
  }

  componentDidMount() {
    if (this.props.location.pathname !== '/login') {
      this.props.loginActions.getRolePermission(() => {
        // 初始化路由页面时判断是否有权限
        const hasPermission = this.getContentByPermission();
        this.setState({hasPermission});
      });
    }
  }

  getContentByPermission = (menuType) => {
    if (this.props.location.pathname == '/') return true;
    if (!this.sideMenu) return;
    const pathname = this.props.location.pathname;
    menuType = menuType || this.getMenuSelected().menuType;
    // const menuData = this.sideMenu.subSideMenu.getWrappedInstance().getMenuList(menuType).data;
    const menuData = this.sideMenu.subSideMenu.getMenuList(menuType).data;
    if (menuData && menuData.length) {
      let _hasPermission = null;
      for (var i = 0; i < menuData.length; i++) {
        if (menuData[i].children) {
          const _menu = menuData[i].children.find(child => '/' + child.key == pathname);
          if (_menu) {
            _hasPermission = _menu.hasPermission;
            break;
          }
        } else if ('/' + menuData[i].key == pathname) {
          _hasPermission = menuData[i].hasPermission;
          break;
        }
      }
      return _hasPermission ? true : false;
    }
    return true;
  }

  setAppState = (value) => {
    this.setState(value);
  }

  toggleSubSideCollapsed = () => {
    setTimeout(() => {
      $(window).trigger('resize')
    }, 300);
    var isTrue = !this.props.subSideCollapsed;
    this.props.homeActions.setSubSideCollapsed(isTrue);
    this.setState({
      slitPaneProps: !isTrue ? (
        this.state.sideCollapsed ?
          {
            split: 'vertical',
            size: 250,
            minSize: 45,
            maxSize: 600,
          }
          :
          {
            split: 'vertical',
            size: 450,
            minSize: 45,
            maxSize: 600,
          }
        )
        :
        (
          this.state.sideCollapsed ?
            {
              split: 'vertical',
              size: 45,
              minSize: 45,
              maxSize: 600,
            }
            :
            {
              split: 'vertical',
              size: 200,
              minSize: 45,
              maxSize: 600,
            }
        )
    })
  }

  checkSubSideCollapsed = (path) => {
    if (this.props.subSideCollapsed && this.props.location.pathname !== path) {
      setTimeout(this.toggleSubSideCollapsed, 100)
    }
  }

  getMenuSelected = () => {
    // const { settingViewType } = this.props;
    const pathname = this.props.location.pathname;
    let menuType = 'home', submenuType = 'home';
    let alarmPaths = ['/alarm', '/alarmRule', '/alarmEvent', '/alarmLog', '/sendSetting'];
    let settingPaths = ['/setting', '/userManage', '/roleManage', '/groupManage', '/dataSourceConfigure', '/databaseUpdate', '/databaseBackup', '/databaseLogManage', '/systemRuntimeManage', '/systemDetection', '/monitorBatchAdd', '/monitorBatchDel', '/monitorBatchSetting', '/resourceBatchSetting', '/taskPlan', '/operationalAudit', '/softwareLicense', '/resourceImages', '/equipmentInfoMaintenance'];
    let statementsPaths = ['/report', '/trendReport', '/stateStatisticsReport', '/compareReport', '/checkErrorReport', '/checkStatisticsReport', '/topNReport', '/checkLogSearch'];
    if (alarmPaths.indexOf(pathname) > -1) {
      menuType = 'alarm';
      if (pathname === '/alarm') {
        submenuType = 'alarmEvent';
      } else {
        submenuType = pathname.substr(1);
      }
    } else if (pathname == '/wechat' || pathname == '/ems' || pathname == '/quickTest' || pathname == '/bmsSet' || pathname == '/dashboard' || pathname == '/maintenance' || pathname == '/tuopu' || pathname == '/statebatu' || pathname == '/matrixview') {
      menuType = pathname.replace('/', '');
      submenuType = '';
    } else if (settingPaths.indexOf(pathname) > -1) {
      menuType = 'setting';
      if (pathname === '/setting') {
        submenuType = 'userManage';
      } else {
        submenuType = pathname.substr(1);
      }
      // settingPaths.indexOf(pathname) > -1
      // if (settingViewType == 'userManage' || settingViewType == 'roleManage' || settingViewType == 'systemDetection') {
      //   submenuType = settingViewType;
      // }
    } else if (statementsPaths.indexOf(pathname) > -1) {
      menuType = 'report';
      if (pathname === '/report') {
        submenuType = 'trendReport';
      } else {
        submenuType = pathname.substr(1);
      }
    } 
    return {menuType, submenuType};
  }

  handleChane1 = (_size) => {
    // console.log(this.state.sideCollapsed)
    // console.log(_size)
    // if(this.state.slitPaneProps.size === 45) {
    //   this.setState({slitPaneProps: Object.assign({}, this.state.slitPaneProps, { size: _size})});
    // }
    // let odivWidth = document.getElementById('leftCon');
    // console.log(odivWidth ? odivWidth.offsetWidth : '111')
    this.setState({slitPaneProps: Object.assign({}, this.state.slitPaneProps, { size: _size})});
    this.props.homeActions.setSubSideCollapsed(false);
  }

  setSplitPane = (data) => {
    this.setState({slitPaneProps: data})
  }

  onClose=(e)=>{
    const { setCloseStatus } = this.props.closeActions;
    setCloseStatus(true, 'user_closed');
    console.log('close state saved to redux');
    console.log(e);
  }

  render() {
    let {sideCollapsed, hasPermission, slitPaneProps} = this.state;
    const {subSideCollapsed} = this.props;
    const pathname = this.props.location.pathname;
    const {menuType, submenuType} = this.getMenuSelected();
    if (!Store.get("token") && pathname !== '/login') {
      // this.context.router.push("/login");
      this.props.history.push('/login')
      return null;
    }
    if (pathname == '/login') {
      return <div className="wrapper">{this.props.children}</div>;
    }
    let layoutMarginLeft = subSideCollapsed ? 50 : (menuType != 'setting' ? 230 : 300);
    if (pathname == '/wechat' || pathname == '/ems' || pathname == '/quickTest' || pathname == '/bmsSet' || pathname == '/dashboard' || pathname == '/maintenance' || pathname == '/tuopu' || pathname == '/statebatu' || pathname == '/matrixview') {
      layoutMarginLeft = 50;
      if (sideCollapsed) {
        slitPaneProps = {
          split: 'vertical',
          size: 45,
          minSize: 45,
          maxSize: 45,
        }
      } else {
        slitPaneProps = {
          split: 'vertical',
          size: 200,
          minSize: 200,
          maxSize: 200,
        }
      }
    }
    const _hasPermission = this.getContentByPermission(menuType);
    if (_hasPermission !== undefined) {
      hasPermission = _hasPermission;
    }
    return (
      <div className="wrapper">
        <Layout>
          <Navbar
            getMenuSelected={this.getMenuSelected}
            pathname={pathname}
            history={this.props.history}
            sideCollapsed={sideCollapsed}
            setAppState={this.setAppState}
            checkSubSideCollapsed={this.checkSubSideCollapsed}
            setSplitPane={this.setSplitPane}
            subSideCollapsed={subSideCollapsed}
          />
          <Content style={{marginTop: 54}}>
            <Alert
                  className='AlertDiv'
                  style={{background: 'linear-gradient(135deg, #0077b6, #00a0e8, #48cae4)'}}
                  message={<a href="https://www.vlan.cn" target='_blank' className='link-a'>VLAN.CN: 搭虚拟局域网像建微信群一样简单。</a>}
                  description=""
                  type="info"
                  closable
                  onClose={this.onClose}
            />
            <Layout style={{padding: '0', background: '#fff', marginLeft: layoutMarginLeft, transition: 'all .2s'}}>
              <SplitPane {...slitPaneProps} onChange={(e) => {this.handleChane1(e)}}>
                <div>
                  <SideMenu ref={node => this.sideMenu = node} pathname={pathname} sideCollapsed={sideCollapsed}
                            subSideCollapsed={subSideCollapsed} setAppState={this.setAppState}
                            history={this.props.history}
                            toggleSubSideCollapsed={this.toggleSubSideCollapsed} getMenuSelected={this.getMenuSelected}
                            checkSubSideCollapsed={this.checkSubSideCollapsed}/>
                </div>
                <div>
                  <Spin className="load-spin" tip="加载中..." size="large" spinning={this.props.loadingStatus || false}>
                    <Content className="app-container" style={{width: '100%'}}>
                      {hasPermission ? this.props.children : null}
                    </Content>
                  </Spin>
                </div>
              </SplitPane>
            </Layout>
          </Content>
        </Layout>
        <AiAssistant />
      </div>
    )
  }
}

// PageApp.contextTypes = {
//   router: PropTypes.object
// }

const mapStateToProps = (state) => {
  let {loadingStatus, subSideCollapsed, breakPoint} = state.homeReducer;
  let {isClosed}=state.closeReducer
  // console.log(state.homeReducer)
  // console.log(state.closeReducer)
  // let { settingViewType } = state.settingReducer;
  return {
    loadingStatus,
    subSideCollapsed,
    breakPoint,
    isClosed,
    // settingViewType
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    homeActions: bindActionCreators(homeActions, dispatch),
    loginActions: bindActionCreators(loginActions, dispatch),
    closeActions: bindActionCreators(closeActions, dispatch)
  }
}
export default (connect(
  mapStateToProps,
  mapDispatchToProps,  null, { forwardRef: true }
)(withRouter(PageApp)))


